import type { IconJVSProps } from '@mairistem/composants';
import { UserRole } from '@mairistem/finances-utils';
import TypeBudget from '../../constants/simulation/typeBudget';
import type Simulation from '../../interfaces/simulation/simulation';

class BaseOutil {
	code: string;

	icon: IconJVSProps;

	title: string = '';

	getTitle(_simulation: Simulation): string {
		return this.title;
	}

	isCompteAdministratif(simulation: Simulation): boolean {
		return simulation?.budget?.type === TypeBudget.COMPTE_ADMINISTRATIF;
	}

	isEnabled(userRole: UserRole, _simulation: Simulation) {
		return userRole > UserRole.GESTIONNAIRE;
	}

	// Un outil visible (isEnabled) mais inactif est affiché grisé et non cliquable
	isActive(_userRole: UserRole, _simulation: Simulation): boolean {
		return true;
	}

	renderModal(
		_simulation: Simulation,
		_onClose: () => void,
		_onValidate: () => void,
		_open: boolean,
	) {
		return null;
	}
}

export default BaseOutil;
